import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-loan-textarea',
  templateUrl: './loan-textarea.component.html',
  styleUrl: './loan-textarea.component.scss',
  standalone: false
})
export class LoanTextareaComponent {
  @Input({ required: true }) label: string = '';
  @Input() control!: FormControl;
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() cols: number = 50;
  @Input() rows: number = 4;
}
